<section class="sect flex">
    <aside>
        <div class="flex">

            <ul *ngIf="userDetails['status'] !='approved'">
                <li>
                    <div>
                        <a routerLinkActive="linkActive" routerLink="dashboard" class="links flex">
                            <mat-icon class="mat-18">dashboard</mat-icon>
                            <p style="flex: 4;">
                                Dashboard
                            </p>
                        </a>
                    </div>
                </li>
                <li>
                    <div>
                        <a routerLinkActive="linkActive" routerLink="profile" class="links flex">
                            <mat-icon class="mat-18">account_circle</mat-icon>
                            <p style="flex: 4;">
                                Profile
                            </p>
                        </a>
                    </div>
                </li>
            </ul>
            <ul  *ngIf="userDetails['status'] =='approved'">
                <li *ngFor="let link of links">
                    <div>
                        <a routerLinkActive="linkActive" routerLink="{{link.link}}" class="links flex"
                        [class.disabled]="link.link === 'create-policy' && !userDetails['unitFn'] && userDetails['role'] == 'staff'"
                        >
                            <mat-icon class="mat-18">{{link.icon}}</mat-icon>
                            
                            <p style="flex: 4;">
                                {{link.title}}
                            </p>
                        </a>
                    </div>
                </li>
                <li>
                    <div class="info" (click)="more()">
                            <mat-icon>info</mat-icon>
                            <p>More Info.</p> 
                    </div>
                </li>
            </ul>
            <div class="side-footer" (click)="contact()">
                <div class="flex " style="color:white;">
                    <mat-icon class="mic">headset_mic</mat-icon>
                    <p>Contact Us</p>
                </div>
                <!-- <div class="contact" *ngIf="onCollapse">
                    <a href="tel:+2348038721305"><span><b>08038721305</b></span></a>
                    <a href="akinmorin.bolaji@heirsgeneralinsurance.com">
                        <div><b>akinmorin.bolaji@</b></div>
                        <div><b>heirsgeneralinsurance.com</b></div>
                    </a>
                </div> -->
                <button class="links" (click)="logOut()" mat-button style="color:white;">
                    <mat-icon class="mat-18">logout</mat-icon> 
                    <p>Log Out</p>
                </button>
            </div>
        </div>
        
    </aside>
    
    <main>
        <!-- <div (click)="onClick()">
            <mat-icon *ngIf="!onView" class="hambugger">menu</mat-icon>
            <mat-icon *ngIf="onView" class="close">cancel</mat-icon>
        </div> -->
        <router-outlet></router-outlet>
    </main>
</section>